export default __webpack_public_path__ + "static/media/ic_totaluser.e274ef10.svg";